const initializeBootstrapTooltips = () => {
  const scrollContainer = document.getElementById('admin-scroll-container');

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));

  tooltipTriggerList.map(function (tooltipTriggerEl) {
    // console.log('Init tooltip')
    return new bootstrap.Tooltip(tooltipTriggerEl, { container: scrollContainer, boundary: scrollContainer });
  });

  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  popoverTriggerList.map(function (popoverTriggerEl) {
    // console.log('Init popover')
    return new bootstrap.Popover(popoverTriggerEl, { container: scrollContainer, boundary: scrollContainer });
  });
};

module.exports = initializeBootstrapTooltips;
